import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api, { imgUrl } from "../../lib/api";
import { useLang } from "../../i18n";

const BOOKING_STATUSES = ["nuovo", "confermato", "annullato"];

export default function CoursesAdmin() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [bookings, setBookings] = useState([]);

  const load = () => {
    api.get("/courses").then((r) => setCourses(r.data)).catch(() => {});
    api.get("/admin/bookings").then((r) => setBookings(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const updateBooking = async (id, status) => {
    await api.patch(`/admin/bookings/${id}`, { status }).catch(() => {});
    toast.success("✓");
    load();
  };

  const remove = async (id) => {
    await api.delete(`/admin/courses/${id}`).catch(() => {});
    toast.success("✓");
    load();
  };

  return (
    <div data-testid="admin-courses">
      <div className="flex items-center justify-between">
        <h1 className="font-serif text-3xl font-bold">{t("admin.courses")}</h1>
        <button onClick={() => navigate("/admin/corsi/nuovo")} data-testid="admin-new-course-btn"
          className="flex items-center gap-2 bg-gold text-obsidian px-5 py-2.5 text-sm font-semibold hover:bg-honey transition-colors">
          <Plus size={15} /> Nuovo corso
        </button>
      </div>
      <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-slate2 border border-slate-700 rounded-lg p-6" data-testid="admin-courses-list">
          <p className="font-mono text-[10px] uppercase tracking-widest text-slate-400 mb-5">Corsi attivi</p>
          <div className="space-y-4">
            {courses.map((c) => (
              <div key={c.id} className="border-b border-slate-700/60 pb-4 flex items-start gap-4" data-testid={`admin-course-${c.id}`}>
                {c.image && <img src={imgUrl(c.image)} alt="" className="w-14 h-14 object-cover rounded border border-slate-700" />}
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-slate-100">{c.title_it}</p>
                  <p className="text-xs text-slate-400 mt-1">{c.level} · {c.duration} · <span className="font-mono text-gold">€{c.price.toFixed(0)}</span></p>
                  <p className="text-xs font-mono text-slate-500 mt-1">{(c.next_dates || []).join(" · ")}</p>
                </div>
                <div className="flex">
                  <button onClick={() => navigate(`/admin/corsi/modifica/${c.id}`)} data-testid={`edit-course-${c.id}`} className="p-2 text-slate-400 hover:text-gold transition-colors"><Pencil size={15} /></button>
                  <button onClick={() => remove(c.id)} data-testid={`delete-course-${c.id}`} className="p-2 text-slate-400 hover:text-red-400 transition-colors"><Trash2 size={15} /></button>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-slate2 border border-slate-700 rounded-lg p-6" data-testid="admin-bookings-list">
          <p className="font-mono text-[10px] uppercase tracking-widest text-slate-400 mb-5">Richieste di prenotazione</p>
          <div className="space-y-4">
            {bookings.length === 0 && <p className="text-slate-500 text-sm" data-testid="bookings-empty">—</p>}
            {bookings.map((b) => (
              <div key={b.id} className="border-b border-slate-700/60 pb-4 flex items-start justify-between gap-4" data-testid={`admin-booking-${b.id}`}>
                <div>
                  <p className="font-medium text-slate-100">{b.name} <span className="text-slate-500 text-xs">×{b.participants}</span></p>
                  <p className="text-xs text-slate-400">{b.course_title}</p>
                  <p className="text-xs font-mono text-slate-500 mt-1">{b.email} · {b.phone || "—"} · {b.date}</p>
                  {b.notes && <p className="text-xs text-slate-500 mt-1 italic">“{b.notes}”</p>}
                </div>
                <select value={b.status} onChange={(e) => updateBooking(b.id, e.target.value)} data-testid={`booking-status-${b.id}`}
                  className="bg-obsidian border border-slate-600 text-xs text-slate-100 px-2 py-1.5 focus:outline-none focus:border-gold">
                  {BOOKING_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
